import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";
import { routes } from "constants/routes";

export const NotRequireAuth = ({ children }: React.PropsWithChildren<{}>) => {
  const auth: any = useAuth();
  // // get login status from OIDC (IDHUB)
  const isLoggedIn = auth && auth.isAuthenticated;
  if (isLoggedIn) {
    return (
      <Navigate
        to={routes.home.path}
        replace // <-- redirect
      />
    );
  }

  return <>{children}</>;
};
